import React from 'react';
import { Separator } from '../../../ui/separator';

const DividerBlock: React.FC = () => {
  return <Separator className="my-8" />;
};

export default DividerBlock;
